module.exports = __webpack_public_path__ + "static/CleanAir-Mobile-Header-1080x550-Curve-About-2x-41097f852e15b0a5217773a29b5d9a55.png";